import type { CustomFilterMainCreators } from '@/app/common/filters/surfaces/forms/FilterGroupsComponents.tsx';
import React from 'react';
import type { HandleFilterChanged } from '@/app/common/filters/core/filterComponentType.ts';
import { StickyFirstPill } from '@/app/common/filters/surfaces/bar/StickyFirstPill.tsx';
import type { FilterPill } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import { createPortal } from 'react-dom';
import { FloatingLayoutContainer } from '@/app/common/filters/surfaces/bar/floating/styled.ts';
import useIsClient from '@/app/components/search/hooks/useIsClient.ts';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';

export type FloatingLayoutProps = {
  filterPills: FilterPill[];
  customFilterMainCreators: CustomFilterMainCreators;
  isLoading: boolean;
  handleFilterChanged: HandleFilterChanged;
  isDark?: boolean;
};

const NO_LABEL_CREATORS = {};

const FloatingLayout = ({
  filterPills,
  customFilterMainCreators,
  isLoading,
  handleFilterChanged,
  isDark = true,
}: FloatingLayoutProps) => {
  const isClient = useIsClient();
  const { isDesktop } = useCommonClient();
  const filtersBarContainer = isClient ? document.querySelector('.filters-bar-container') : null;
  const showFiltersAtTheBottomOfTheList = !isDesktop && !!filtersBarContainer;

  const filters = (
    <FloatingLayoutContainer isDark={isDark} aria-busy={isLoading}>
      <StickyFirstPill
        filterPills={filterPills}
        customFilterMainCreators={customFilterMainCreators}
        customFilterLabelCreators={NO_LABEL_CREATORS}
        isLoading={isLoading}
        handleFilterChanged={handleFilterChanged}
      />
    </FloatingLayoutContainer>
  );

  if (showFiltersAtTheBottomOfTheList) return createPortal(filters, filtersBarContainer);

  return null;
};

export default FloatingLayout;
